import appManager from '@app/appManager';
import IAppLogger from '@app/lib/IAppLogger';
import { PcsConversationDetailsResult } from '@api/queries/getPcsConversationDetails';

const emitConversationDetailsFetched = (
  callId: string,
  conversationDetails: PcsConversationDetailsResult,
  logger: IAppLogger,
) => {
  logger.info(
    `PCS Conversation Details Fetched: callId: ${callId}, isTransfer: ${conversationDetails.isTransfer}, transferredByUserId: ${conversationDetails.transferredByUserId}`,
  );

  appManager.events.emit('phone.pcs.conversation.conversationdetails.fetched', {
    callId,
    conversationDetails,
  });
};

export default emitConversationDetailsFetched;
